import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { AuthenticatedImage } from '@/components/common/AuthenticatedImage';

interface ChatImageViewerProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
}

export const ChatImageViewer: React.FC<ChatImageViewerProps> = ({
  isOpen,
  onClose,
  imageUrl,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          padding: '8px',
          overflow: 'hidden',
          borderRadius: '12px',
        }}
      >
        <AuthenticatedImage
          src={imageUrl}
          alt="Chat image"
          style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
        />
      </DialogContent>
    </Dialog>
  );
};
